module.exports = __webpack_public_path__ + "img/mailbenachrichtigung.8e03ae48.png";